// Aqua Link vs. competitor water leak sensors, as approved by the president
// (October 2026). Aqua Link's column is his wording; every competitor value comes
// from that manufacturer's own product pages, spec sheets or manuals, listed in
// `sources`. Recheck competitor specs before changing or re-dating this chart.

export const checkedDate = 'October 2026';

export const features = [
    { key: 'battery', label: 'Battery' },
    { key: 'detection', label: 'Detection' },
    { key: 'alerts', label: 'Alerts' },
    { key: 'connectivity', label: 'Connectivity' },
    { key: 'hub', label: 'Hub required?' },
];

export const aquaLink = {
    name: 'Aqua Link',
    model: 'Water Sensor + Smart Hub',
    values: {
        battery: 'Internal 10-year lithium (tamper-proof)',
        detection: 'Water contact + freeze/low-temp',
        alerts: 'On-device & Hub Horn; text, email, app push (up to 8 contacts)',
        connectivity: 'Proprietary RF to Smart Hub',
        hub: 'Yes (Smart Hub)',
    },
};

export const competitors = [
    {
        key: 'yolink',
        short: 'YoLink',
        name: 'YoLink Water Leak Sensor 4',
        model: 'YS7906-UC',
        values: {
            battery: '2× AAA',
            detection: 'Water + low-temperature (freeze) alerts',
            alerts: 'On-device Horn; app push, email, limited free texts',
            connectivity: 'LoRa to YoLink hub',
            hub: 'Yes (YoLink hub)',
        },
        sources: [
            ['Water Leak Sensor 4 product page', 'https://shop.yosmart.com/products/ys7906'],
            ['YS7906-UC installation & user guide', 'https://www.yosmart.com/help/docs/products/YS7906-UC/YS7906-UC_instruction.pdf'],
            ['YoLink app Q&A: text quotas and paid plans', 'https://support.yosmart.com/hc/en-001/articles/17988570459161-YoLink-App-Q-As'],
        ],
    },
    {
        key: 'govee',
        short: 'GoveeLife',
        name: 'GoveeLife Water Leak Detector 1s',
        model: 'H5059 sensor + H5044 gateway',
        values: {
            battery: '2× AAA',
            detection: 'Water only',
            alerts: 'On-device Horn; app push, email',
            connectivity: '915 MHz radio to Govee Wi-Fi gateway',
            hub: 'Yes (H5044 Wi-Fi gateway)',
        },
        sources: [
            ['Smart Water Leak Detector product page and specs', 'https://us.govee.com/products/smart-water-leak-detector'],
            ['H5059 product FAQ', 'https://us.govee.com/support/product-description/H5059'],
            ['H5059/H5044 user manual (Govee document, copy hosted by manuals.plus)', 'https://manuals.plus/goveelife/h5059-water-leak-detector-manual.pdf'],
            ['Water Leak Detector 1s with sensor cable', 'https://us.govee.com/products/goveelife-water-leak-detector-1s-with-sensor-cable'],
        ],
    },
    {
        key: 'moen',
        short: 'Moen',
        name: 'Moen Smart Leak Detector',
        model: '920-004 (formerly Flo by Moen)',
        values: {
            battery: 'CR123A lithium',
            detection: 'Water + humidity + temperature',
            alerts: 'App, text, phone call, email',
            connectivity: 'Direct 2.4 GHz Wi-Fi',
            hub: 'No',
        },
        sources: [
            ['Smart Leak Detector spec sheet (920-004 / 920-005)', 'https://assets.moen.com/shared/docs/product-specifications/spc16265sp.pdf'],
            ['920-004 product page', 'https://moen.com/products/Flo-by-Moen/Flo-by-Moen-Leak-Detection-System/920-004'],
            ['Help center: leak detected', 'https://solutions.moen.com/Smart_Water_Security_Products/Help_Center/Moen_Flo_Detector/Leak_Detected'],
            ['Help center: placement and remote disc', 'https://solutions.moen.com/Smart_Leak_Detector/Product_Installation/Placement_of_Smart_Leak_Detector'],
            ['FloProtect cost', "https://solutions.moen.com/FAQ's/FAQ's-Flo/FloProtect/How_much_does_FloProtect_cost%3F"],
            ['What FloProtect is', "https://solutions.moen.com/FAQ's/FAQ's-Flo/FloProtect/What_is_FloProtect_Plan%3F"],
        ],
    },
    {
        key: 'xsense',
        short: 'X-Sense',
        name: 'X-Sense SWS54',
        model: 'SWS51 sensors + SBS50 base',
        values: {
            battery: '2× AAA',
            detection: 'Water only',
            alerts: 'On-device & Hub Horn; app push',
            connectivity: '915 MHz radio to SBS50 base (2.4 GHz Wi-Fi)',
            hub: 'Yes (SBS50 base station)',
        },
        sources: [
            ['SWS54 product page and FAQ', 'https://www.x-sense.com/products/sws54-smart-water-leak-detector-kit'],
            ['SWS54 user manual', 'https://cdn.shopifycdn.net/s/files/1/0115/9223/7122/files/SWS54-User-Manual.pdf?v=1670815636'],
            ['Protect+ plan (fire alarms only)', 'https://www.x-sense.com/pages/protect-premium'],
        ],
    },
];
